import concurrentAPIRequestsFeatures from './ConcurrentAPIRequests';
import purchaseAdditionalCCRFeatures from './PurchaseAdditionalCCR';
import usageLimitFeatures from './UsageLimit';
import ttsBatchFeatures from './TTSBatch';
import ttsRealtimeFeatures from './TTSRealtime';
import ttsStreamingFeatures from './TTSStreaming';
import sttBatchFeatures from './STTBatch';
import sttRealtimeFeatures from './STTRealtime';
import sttStreamingFeatures from './STTStreaming';

const apiFeatures = ({ packages, canUseVouchers, totalVoucher }) => ({
  usageLimit: {
    key: 'usage-limit',
    label: 'usageLimit',
    values: usageLimitFeatures({ packages, canUseVouchers, totalVoucher }),
    tooltipContent: 'maximumCreditsAllowedForAPIUsage',
  },
  concurrentAPIRequests: {
    key: 'concurrent-API-requests',
    label: 'concurrentAPIRequests',
    values: concurrentAPIRequestsFeatures({ packages }),
  },
  purchaseAdditionalCCR: {
    key: 'purchase-additional-CCR',
    label: 'purchaseAdditionalCCR',
    values: purchaseAdditionalCCRFeatures({ packages }),
  },
});

const apiNewFeatures = ({
  packages,
  canUseVouchers,
  totalVoucher,
  sttAsyncConfig,
  sttSyncConfig,
  sttStreamingConfig,
  ttsAsyncConfig,
  ttsSyncConfig,
  ttsStreamingConfig,
}) => {
  const ttsBatch = ttsBatchFeatures({ packages, ttsConfig: ttsAsyncConfig });
  const ttsRealtime = ttsRealtimeFeatures({
    packages,
    ttsConfig: ttsSyncConfig,
  });
  const ttsStreaming = ttsStreamingFeatures({
    packages,
    ttsConfig: ttsStreamingConfig,
  });
  const sttBatch = sttBatchFeatures({
    packages,
    sttConfig: sttAsyncConfig,
  });
  const sttRealtime = sttRealtimeFeatures({
    packages,
    sttConfig: sttSyncConfig,
  });
  const sttStreaming = sttStreamingFeatures({
    packages,
    sttConfig: sttStreamingConfig,
  });

  return {
    usageLimit: {
      key: 'usage-limit',
      label: 'usageLimit',
      values: usageLimitFeatures({ packages, canUseVouchers, totalVoucher }),
      tooltipContent: 'maximumCreditsAllowedForAPIUsage',
    },
    ttsBatch: {
      ...ttsBatch.enabled,
      type: 'sub-group',
      label: 'ttsBatch',
      children: [
        { ...ttsBatch.concurrentCCR, label: 'concurrentAPIRequests' },
        {
          ...ttsBatch.purchaseAdditionalCCR,
          label: 'purchaseAdditionalCCR',
        },
      ],
    },
    ttsRealtime: {
      ...ttsRealtime.enabled,
      type: 'sub-group',
      label: 'ttsRealtime',
      children: [
        { ...ttsRealtime.concurrentCCR, label: 'concurrentAPIRequests' },
      ],
    },
    ttsStreaming: {
      ...ttsStreaming.enabled,
      type: 'sub-group',
      label: 'ttsStreaming',
      children: [
        { ...ttsStreaming.concurrentCCR, label: 'concurrentAPIRequests' },
      ],
    },
    sttBatch: {
      ...sttBatch.enabled,
      type: 'sub-group',
      label: 'sttBatch',
      blockDuration: sttAsyncConfig?.blockDuration,
      children: [{ ...sttBatch.concurrentCCR, label: 'concurrentAPIRequests' }],
    },
    sttRealtime: {
      ...sttRealtime.enabled,
      type: 'sub-group',
      label: 'sttRealtime',
      blockDuration: sttSyncConfig?.blockDuration,
      children: [
        { ...sttRealtime.concurrentCCR, label: 'concurrentAPIRequests' },
      ],
    },
    sttStreaming: {
      ...sttStreaming.enabled,
      type: 'sub-group',
      label: 'sttStreaming',
      blockDuration: sttStreamingConfig?.blockDuration,
      children: [
        { ...sttStreaming.concurrentCCR, label: 'concurrentAPIRequests' },
      ],
    },
  };
};

export default apiFeatures;
export { apiNewFeatures };
